import React, { useState } from 'react';
import * as firebaseAuth from 'firebase/auth';
import { Avatar, Box, Button, Checkbox, FormControlLabel, Grid, InputAdornment, Link, TextField, Typography } from '@mui/material';
import { EmailRounded, LockRounded, PasswordRounded } from '@mui/icons-material';
import isEmail from 'validator/lib/isEmail';

export const SignIn = () => {
  const [emailInvalidFlag, setEmailInvalidFlag] = useState(false);
  const [emailHelperText, setEmailHelperText] = useState('');

  const [passwordHelperText, setPasswordHelperText] = useState('');
  const [passwordInvalidFlag, setPasswordInvalidFlag] = useState(false);
  
  const validateEmail = (email: string) => {
    if (email && email.trim() && email.includes('@')) {
      if (!isEmail(email)) {
        setEmailInvalidFlag(true);
        setEmailHelperText('Enter valid email address.')
        return false;
      }
    } else if (email.trim() === '') {
      setEmailHelperText('Enter your email address.')
      return false;
    }
    setEmailHelperText('');
    return true;
  }

  const validatePassword = (password: string) => {
    if (password && password.trim()) {
      setPasswordHelperText('');
      return true;
    }

    setPasswordInvalidFlag(true);
    setPasswordHelperText('Please enter your password.')
    return false;
  };

  const handleEmailOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (emailInvalidFlag) {
      validateEmail(event.currentTarget.value);
    }
  };

  const handleEmailOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    validateEmail(event.currentTarget.value);
  };

  const handlePasswordOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (passwordInvalidFlag) {
      validatePassword(event.currentTarget.value);
    }
  };

  const handleFormOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const isEmailValid = validateEmail(data.get('email')!.toString());
    const isPasswordValid = validatePassword(data.get('password')!.toString());
    if (!isEmailValid || !isPasswordValid)
      return;

    const email = data.get('email')!.toString();
    const password = data.get('password')!.toString();

    firebaseAuth.signInWithEmailAndPassword(firebaseAuth.getAuth(), email.includes('@') ? email : `u_${email}@nadafa-ems.com`, password)
      .catch((error) => {
        console.log(error.code);
        console.log(error.message);
      });
  };

  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main', width: 96, height: 96 }}>
        <LockRounded sx={{ fontSize: 64 }} />
      </Avatar>
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <Box component="form" method="POST" onSubmit={handleFormOnSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email / Id Number"
          name="email"
          // autoComplete="email"
          error={emailHelperText !== ''}
          helperText={emailHelperText}
          onChange={handleEmailOnChange}
          onBlur={handleEmailOnBlur}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailRounded />
              </InputAdornment>
            ),
          }}
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          error={passwordHelperText !== ''}
          helperText={passwordHelperText}
          onChange={handlePasswordOnChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordRounded />
              </InputAdornment>
            ),
          }}
        />
        {/* <FormControlLabel
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        /> */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 3, mb: 2 }}
        >
          Sign In
        </Button>
        <Grid container>
          <Grid item xs>
            {/* <Link href="#" variant="body2">
              Forgot password?
            </Link> */}
          </Grid>
          <Grid item>
            {/* <Link href="#" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link> */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};